import React from "react";
import Section from "../components/Section";

const PERMISSIONS = [
  ["📷", "Camera", "Capture photos of food for your reviews. Photos are used only when you submit a review."],
  ["🖼️", "Photo Library", "Select existing photos from your library to attach to food reviews."],
  ["📍", "Location (When In Use)", "Find restaurants near you to review. Location is used on-demand and is not stored or tracked continuously."],
  ["🎙️", "Microphone", "Capture video with audio for food review content, if you choose to record video."],
  ["🔔", "Push Notifications", "Receive updates, review responses, and relevant announcements. You can disable this in device settings at any time."]
];

function DevicePermissions() {
  return (
    <Section id="device-permissions" icon="🔒" title="Device Permissions">
      <p>
        The App requests the following device permissions. All permissions are optional where possible
        and are used only for the stated purpose. Data accessed via these permissions is processed
        on-device or used solely within the feature you initiate — it is never transmitted off-device
        without your action.
      </p>

      <div className="permission-grid">
        {PERMISSIONS.map(([icon, name, desc]) => (
          <div className="permission-card" key={name}>
            <div className="perm-icon">{icon}</div>
            <h4>{name}</h4>
            <p>{desc}</p>
          </div>
        ))}
      </div>
    </Section>
  );
}

export default DevicePermissions;
